import * as React from 'react';
import Component from './SingleDateRangePicker';
import type { SingleDateRangePickerProps_ } from './SingleDateRangePicker';
import { LocalizationProvider } from './DatePickerLocalization';

type SingleDateRangePickerProps = SingleDateRangePickerProps_;

export type { SingleDateRangePickerProps };

export function DateRangePicker(props: SingleDateRangePickerProps) {
  return (
    <LocalizationProvider value={props.localizationData}>
      <Component {...props} />
    </LocalizationProvider>
  );
}
